import React from 'react';
import { useFormContext } from 'react-hook-form';

import LeafletMap from '../map/LeafletMap';
import EventMarker from '../map/EventMarker';


const EventMap = ({ formData }) => {
    const formContext = useFormContext();

    const handleChangePosition = (e) => {
        formContext.setValue('lat', e.latlng.lat);
        formContext.setValue('lng', e.latlng.lng);
    };

    return (
        <LeafletMap onClick={handleChangePosition}>
            {(formData.lat && formData.lng) && (
                <EventMarker data={{ lat: formData.lat, lng: formData.lng }} />
            )}
        </LeafletMap>
    );
};

export default EventMap;
